import React, { useState, useEffect, useContext,useCallback } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import CarnivalForm from './carnivalForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import 'react-toastify/dist/ReactToastify.css';
import Regex from 'services/utils/regex/Regex'; 

const AddCarnivalThroughStage = ({
  match,
  history,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  getLeadInfraId,
  leadInfraId,
  saveCarnival,
  getCarnivalDataForUpdation,
  carnivalData,
  updateCarnivalData
}) => {
  const [isFiled, setIsFiled] = useState(false);
  // const [siteId, setSiteId] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [infraIdMissingModal, setIsInfraIdMissingModal] = useState(false);
  const [details, setDetails] = useState(null);
  const [meetingData, setCorporateData] = useState(inputs);
  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const [carnivalType, setCarnivalType]=useState('carnival');

  useEffect(() => {
    if(match?.params?.carnival_type!=undefined && match?.params?.carnival_type!=null){
        if(match?.params?.carnival_type=='helpdesk'){
            setCarnivalType('Helpdesk')
        }else{
            setCarnivalType('Carnival')
        }
    }else{
        setCarnivalType('Carnival')
    }
  }, [match?.params?.carnival_type]);

  //For Updating Carnival
  const getCarnivalData = useCallback(async () => {
    if (match?.params?.id) {
      setIsLoading(true);
      await getCarnivalDataForUpdation(match?.params?.id);
      setIsLoading(false);
    }
  }, [getCarnivalDataForUpdation, match?.params?.id]);

  useEffect(() => {
    getCarnivalData();
  }, [getCarnivalData]);


  //End Carnival Updation

  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    if (meetingDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      const updatedMeetingDetails = meetingDetails;
      const requiredFields = [
        'event_status', 
        'total_footfall', 
        'manpower_required', 
        'partners',
        'location', 
        'lat', 
        'lng'
      ];

      // let missingFields = requiredFields.filter(field => {
      //   return !updatedMeetingDetails[field] || updatedMeetingDetails[field].trim() === '';
      // });

      let missingFields = requiredFields.filter((field) => {
        const value = updatedMeetingDetails[field];
        if (value === undefined || value === null) return true;
        if (typeof value === 'string' && value.trim() === '') return true;
        return false;
      });

      if (missingFields.length > 0) {
        const formattedFields = missingFields.map(field =>
          field.replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize first letter of each word
        );
        toast.error(`Please fill all required fields: ${formattedFields.join(', ')}`);
        return;
      }

      if(updatedMeetingDetails.gst_number!== '' && updatedMeetingDetails.gst_number !== null && Regex.gstRegex.test(updatedMeetingDetails.gst_number) === false){
          toast.error('Invalid GST number. GSTIN must be 15 characters long and match the format: 11AAAAA1111A1Z1.');
          return false;
      }

      if (
        Array.isArray(updatedMeetingDetails.partners) &&
        updatedMeetingDetails.partners.length > 0 &&
        updatedMeetingDetails.partners.some(
          (partner) =>
            (partner.companyName?.trim() && !partner.cost?.trim()) ||
            (!partner.companyName?.trim() && partner.cost?.trim())
        )
      ) {
        toast.error(`Please fill both Company Name and Cost for all partners`);
        return;
      }

      /*let totalPrice = 0;
      meetingDetails.services.map((x,i) => 
          totalPrice += Number(x.price)
      );
      if (totalPrice != 1000) {
        toast.error('Sum of prices should be 1000!');
        return;
      }
      if (meetingDetails.rwa_members === 1) {
          let isNotEmpty = true;
          isNotEmpty = meetingDetails.members.map((x,i) => { 
            return (handleValidateObj(x) == false) ? (
                  false
            ) : null}
          );
          if (isNotEmpty.includes(false)) {
            toast.error('Please fill all details of RWA members!');
            return;
          }
      } else if (meetingDetails.rwa_members === 2) {
          if (meetingDetails.rwaImage == null || meetingDetails.rwaImage == '') {
            toast.error('Please upload RWA Image');
            return;
          }
      } else {
          toast.error('Please fill member details!');
          return;
      }*/

      setIsFiled(false);
      if (updatedMeetingDetails?.isEdit == 1) {
        (async () => {
          const res = await updateCarnivalData(updatedMeetingDetails);
          if (res) {
            setIsModal(true);
          }
        })();
      } else {
        (async () => {
          const res = await saveCarnival(updatedMeetingDetails);
          if (res) {
            setIsModal(true);
          }
        })();
      }
    }
  };

  const handleModalHide2 = () => {
    setIsInfraIdMissingModal(false);
    history.push(`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${match?.params?.siteId}`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        Schedule Carnival/Helpdesk
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title='Schedule Carnival/Helpdesk'
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
    >
      <CarnivalForm
        handleValue={handleForm}
        getLeadInfraId={getLeadInfraId}
        // siteId={siteId}
        leadInfraId={leadInfraId}
        documentUploadUrl={documentUploadUrlPublic}
        documentUrlData={documentUrlDataPublic}
        prefilledData={carnivalData}
        match={match}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide2}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{meetingData?.meetingDetails?.isEdit == 1 ? localization.carnivalUpdateSuccess : localization.carnivalSuccess}</h5>
          <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
            {localization.goToCarnivalListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

AddCarnivalThroughStage.propTypes = {};

export default AddCarnivalThroughStage;
